module.exports = __webpack_public_path__ + "img/battlebg.6519a811.webp";